// Presentation evidence, not a launch owner. Mode changes must not reset it.
let loadedIdentity = null;
const identity = (launch) => launch?.playUrl ? `${launch.openedAt || ''}:${launch.playUrl}` : null;
export const markGameFrameLoaded = (launch) => { loadedIdentity = identity(launch); };
export const isGameFrameLoaded = (launch) => Boolean(identity(launch) && loadedIdentity === identity(launch));
